import { render, staticRenderFns } from "./RoleStaff.vue?vue&type=template&id=a68d5cbc&scoped=true"
import script from "./RoleStaff.vue?vue&type=script&lang=js"
export * from "./RoleStaff.vue?vue&type=script&lang=js"
import style0 from "./RoleStaff.vue?vue&type=style&index=0&id=a68d5cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68d5cbc",
  null
  
)

export default component.exports